import React from 'react';
import TextInput from '../../components/form/TextInput';
import STRINGS from './../../data/language/language';
import MainTitle from '../../components/page/main-title/MainTitle';
import ItemExercicio  from './ItemExercicio';
import TreinoAcademia  from './TreinoAcademia';
import TreinoCasa  from './TreinoCasa';

const ACADEMIA = 'academia';

export default class Detail extends React.Component{
  constructor (props){
    super(props);

    this.state = {
      lista: [],
      strings: STRINGS[window.LANGUAGE]
    };

    this.getExercicios = this.getExercicios.bind(this);

  }

  getExercicios(){
    const data = this.props.data;
    let lista = data.exercicios.map((value, i) =>
      <ItemExercicio data={value} key={i} />
    );

    return lista;
  }

  getAcademiaBox() {
    const data = this.props.data;
    const strings = this.state.strings;

    return(
      <TreinoAcademia
        data={data}
        getExercicios={this.getExercicios}
        strings={strings}
      />
    );
  }

  getCasaBox() {
    const data = this.props.data;
    const strings = this.state.strings;

    return(
      <TreinoCasa
        data={data}
        getExercicios={this.getExercicios}
        strings={strings}
      />
    );
  }

  render(){
    const data = this.props.data;
    const strings = this.state.strings;
    const box = data.local === ACADEMIA ? this.getAcademiaBox() : this.getCasaBox();
    return(
      <div>
      <MainTitle title={strings.titleTreino}></MainTitle>
      {box}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/treino/Detail.js